// extracted by mini-css-extract-plugin
export var black = "_4i-6";
export var brand = "_4i-1";
export var ddefault = "_4i-0";
export var error = "_4i-3";
export var gray = "_4i-2";
export var highContrast = "_4i-8";
export var outline = "_4i-7";
export var success = "_4i-5";
export var warning = "_4i-4";